import { RePasswordComponent } from '../../components/RegisterSystem/RePasswordComponent';
import { Footer } from "../../components/share/Footer";
// import { NavMenu } from "../../components/NavMenu";
import { HeadTitle } from "../../components/share/HeadTitle";
import { NavbarIndexComponent } from "../../components/share/NavbarIndexComponent";

export function RePasswordContainer() {
    const titleName = "ลืมรหัสผ่าน/เปลี่ยนรหัสผ่าน";
    return (
        <div className="page-container bg-landing">
            {/* <NavMenu /> */}
            <NavbarIndexComponent />
            <HeadTitle title={titleName} />
            <RePasswordComponent />
            <Footer />
        </div>
    );
}
